import logger from './logger';
/**
 * Centralized auth token storage.
 * All token read/write must go through this module — never access localStorage directly for auth_token.
 * Keeps token in memory (primary) and sessionStorage (persistence within tab session).
 *
 * Security note: sessionStorage is still accessible via XSS. For full protection,
 * migrate to httpOnly cookies set by the server (see backlog P9).
 */
const TOKEN_KEY = 'auth_token';

let _memoryToken = null;

// Initialize from storage on module load
try {
  _memoryToken = sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
  // Migrate from localStorage to sessionStorage if found
  if (localStorage.getItem(TOKEN_KEY)) {
    sessionStorage.setItem(TOKEN_KEY, localStorage.getItem(TOKEN_KEY));
    localStorage.removeItem(TOKEN_KEY);
  }
} catch (err) {
  logger.warn('[tokenStore] Failed to read token from storage:', err?.message);
}

export const tokenStore = {
  get() {
    return _memoryToken;
  },

  set(token) {
    _memoryToken = token;
    try {
      if (token) {
        sessionStorage.setItem(TOKEN_KEY, token);
      } else {
        sessionStorage.removeItem(TOKEN_KEY);
      }
    } catch (err) {
      logger.warn('[tokenStore] Failed to write token to sessionStorage:', err?.message);
    }
  },

  clear() {
    _memoryToken = null;
    try {
      sessionStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(TOKEN_KEY); // Clean up any legacy localStorage tokens
    } catch (err) {
      logger.warn('[tokenStore] Failed to clear token from storage:', err?.message);
    }
  },
};
